import type { DirectiveBinding } from 'vue';

let scrollDom: HTMLElement;
let currentDom: HTMLElement;

// 平滑移动，里面的数值都可以使用参数形式传入。这里直接写成固定值了。
const smooth = () => {
  let distance = scrollDom.scrollTop;
  const step = (distance / 300) * 10;
  const timer = setInterval(() => {
    distance = distance - step;
    if (distance <= 0) {
      clearInterval(timer);
      scrollDom.scrollTop = 0;
      return false;
    }
    scrollDom.scrollTop = distance;
  }, 10);
};

const handleScrolDom = (e: Event) => {
  scrollDom = e.target as HTMLElement;
  if (scrollDom.scrollTop === 0) {
    currentDom.style.display = 'none';
  } else {
    currentDom.style.display = 'block';
  }
};

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    currentDom = el;
    const { scrollSelector = '', isHidden = true } = binding.value;
    // 默认隐藏
    if (isHidden) {
      el.style.display = 'none';
    }
    scrollDom = scrollSelector ? document.querySelector(scrollSelector) : window;
    scrollDom?.addEventListener('scroll', handleScrolDom);

    // 点击监听
    el?.addEventListener('click', smooth);
  },
  unmounted(el: HTMLElement, binding: DirectiveBinding) {
    const { scrollSelector = '' } = binding.value;
    scrollDom = scrollSelector ? document.querySelector(scrollSelector) : window;
    scrollDom?.removeEventListener('scroll', handleScrolDom);
    el?.removeEventListener('click', smooth);
  },
};
